import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, Transition as _Transition, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-header-group-navi__header" }
const _hoisted_2 = { class: "p-header-group-navi__heading__icon" }
const _hoisted_3 = { class: "p-header-group-navi__list c-common-rounded-shadow" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowBottom = _resolveComponent("IconArrowBottom")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_touch = _resolveDirective("touch")!

  return (_ctx.groups && _ctx.groups.length > 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(_ctx.zIndexStyle),
        class: "p-header-group-navi"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(["p-header-group-navi__heading", _ctx.buttonClass]),
            onClick: [
              _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchShownState && _ctx.switchShownState(...args))),
              _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            ]
          }, [
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.textColor }),
              class: "p-header-group-navi__heading__text"
            }, _toDisplayString(_ctx.truncate(_ctx.groupLabel, _ctx.trimTextLength)), 5),
            _createElementVNode("i", _hoisted_2, [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24",
                "icon-color": _ctx.iconColor
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowBottom)
                ]),
                _: 1
              }, 8, ["icon-color"])
            ])
          ], 2)), [
            [_directive_touch, void 0, "tap"]
          ])
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, ({ id, name }, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  class: "p-header-group-navi__list__item",
                  onClick: _withModifiers(($event: any) => (_ctx.updateGroupId(id, name)), ["prevent","stop"])
                }, [
                  _createElementVNode("input", {
                    id: `${_ctx.idPrefix}-${id}`,
                    type: "radio",
                    class: "p-header-group-navi__input",
                    value: id
                  }, null, 8, _hoisted_5),
                  _withDirectives((_openBlock(), _createElementBlock("label", {
                    for: `${_ctx.idPrefix}-${id}`,
                    class: "p-header-group-navi__label c-common-rounded-shadow__label"
                  }, [
                    _createTextVNode(_toDisplayString(name), 1)
                  ], 8, _hoisted_6)), [
                    [_directive_touch, void 0, "tap"]
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ], 512), [
              [_vShow, _ctx.shown]
            ])
          ]),
          _: 1
        })
      ], 4))
    : _createCommentVNode("", true)
}